/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 19/7/2024
 */

import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { openNotificationForm } from "../../Store/Slices/notificationSlice";
import EditNotification from "./EditNotification";

const NotificationDialog = () => {
    const dispatch = useDispatch();
    const notification = useSelector((state) => state.notification);
    const [roles, setRoles] = useState("")

    useEffect(() => {
      const getRoles = () => {
        if (typeof window !== undefined) {
          setRoles(sessionStorage.getItem("roles"));
        }
      }
      getRoles()
    }, [])

    let content;
    let deleteView = false

    if (notification.notificationStatus === "edit") {
      content = roles?.split(",").includes("PRIV_ES_EDITNOTIFICATION") && <EditNotification/>;
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth="lg"
                open={notification.notificationPageOpen}
                onClose={() => dispatch(openNotificationForm(false))}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>{content}</DialogContent>
            </Dialog>
        </>
    );
};

export default NotificationDialog;